import React from "react";
import { useCitationsResults } from "./CitationsResults.hook";
import { CitationCard } from "./CitationCard";

export const CitationsResults: React.FC = () => {
    const { loading, data, error, hasCitations } = useCitationsResults();

    // Don't show anything while loading or if there's an error
    if (loading || error) {
        return null;
    }

    // Only show if we have citations
    if (!hasCitations || !data) {
        return null;
    }

    return (
        <div style={{ marginBottom: "0" }}>
            <CitationCard citation={data} />
        </div>
    );
};
